import { GridCellProps } from "@progress/kendo-react-grid";
import { DatePicker, DatePickerChangeEvent } from "@progress/kendo-react-dateinputs";
import { formatDate } from "@telerik/kendo-intl";
import React from "react";
import { kendoDefaultDateFormatddMMyyyy } from "../../../Utils/dates";
import { ProposedFtlRoute } from "./ProposedFtlRoute";

type LaunchDateKey<T, U extends keyof T> = Extract<keyof T, U>;

type Props = {
  gridCellProps: GridCellProps;
  editable?: boolean;
  highlightValue?: boolean;
  handleDatePickerChange: (proposedFtlRoute: ProposedFtlRoute) => void;
  launchDateKey: LaunchDateKey<ProposedFtlRoute, "LaunchDate" | "ReturnLaunchDate">;
  disabled?: boolean;
};

export const EditableDateCell = ({
  gridCellProps,
  editable,
  highlightValue,
  handleDatePickerChange,
  launchDateKey,
  disabled,
}: Props) => {
  const { dataItem, field, onChange } = gridCellProps;
  const colorForCalculatedDate = "#8c8989";

  const handleChange = (e: DatePickerChangeEvent) => {
    const routeNew = ProposedFtlRoute.toProposedFtlRoute(dataItem);

    handleDatePickerChange({
      ...routeNew,
      [launchDateKey]: e.value ?? undefined,
    });

    if (onChange) {
      onChange({
        dataIndex: 0,
        dataItem,
        field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
    }
  };

  const myField = field || "";
  const dataValue = dataItem[myField] ?? null;

  const formattedDate = !dataValue
    ? ""
    : formatDate(new Date(dataValue), kendoDefaultDateFormatddMMyyyy);

  return (
    <td style={{ color: highlightValue ? colorForCalculatedDate : undefined }}>
      {editable && dataItem.selected ? (
        <DatePicker value={dataValue} onChange={handleChange} disabled={disabled} />
      ) : (
        formattedDate
      )}
    </td>
  );
};
